const SCOPE = "/desktop/";

let _current_registration;

function setVapidKeysAsReloaded(vapid_key_data) {
  // rather than a timestamp we should have a version number
  const data = {...vapid_key_data, timestamp: new Date().getTime()};
  localStorage.setItem("reloaded-vapid-keys", JSON.stringify(data))
}
// don't compare w/ server keys for now
function shouldReloadVapidKeys() {
  return localStorage.getItem("reloaded-vapid-keys") == null;
}


function fetchVapidPublicKey() {
  return new Promise((resolve, reject) => {
    fetch("/api/v1/notification/vapid_public_key", {
      method: "get",
      redirect: "error",
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      }
    }).then((response) => {
        // should redirect
        if (response.status === 200) {
          response.json().then(data => { resolve(data) })
        } else {
          reject({ error: {type: "http", value: response.status} })
        }
    }).catch((error) => {
      if (error.message.startsWith("Not allowed to follow a redirection")) {
        reject({ error: { type: "loggedout", value: null } });
      } else {
        reject({ error: {type: "unknown", value: error } });
      }
    })
  })
}

export function getRegistration() {
  return navigator.serviceWorker.getRegistration(SCOPE).then(function(registration) {
    _current_registration = registration;
    return registration;
  })
}

export function swRegistrationUpdate() {
  console.log("[sw] reg.update()")
  return getRegistration().then((registration) => {
    return registration && registration.update();
  })
}



export function updateFound() {
  return getRegistration().then((registration) => {
    if (! registration) {
      return Promise.reject({error: "no registration"});
    } else {
      return registration.installing || registration.waiting;
    }
  })
}

function registerSubscriptionOnServer(subscription, mode) {
  console.log("pushManager subscribed", subscription)

  fetch(`/api/v1/notification/register?mode=${mode}`, {
      method: "POST",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ subscription  })
  })
}

// called when the apps start
export function ensureSubscribeAndUpdate() {
  console.log("[push] ensure subscribe");

  return getRegistration().then(function(registration) {
    if (! registration) {
      return Promise.reject({error: "no registration"});
    }

    console.log("[sw] reg.update()")
    registration.update();

    return registration.pushManager.getSubscription().then(sub => {
      if (sub) {
	if (shouldReloadVapidKeys()) {
	  return unsubscribe(registration).then(() => {
	    return subscribe(registration);
	  })
	} else {
	  console.log("[push] already subscribed", sub);
	  registerSubscriptionOnServer(sub, "update");
	  return sub;
	}
      } else {
	return subscribe(registration);
      }
    })
  });
}

export function subscribe(registration) {
  console.log("subscribing to registration: ", registration);

  if (!registration) {
    return Promise.reject({error: "No registration"})
  }

  return fetchVapidPublicKey().then((vapid_key_data) => {
    return registration.pushManager.subscribe({ userVisibleOnly: true, ...vapid_key_data })
      .then((subscription) => {
	console.log("pushManager subscribed", subscription)

	setVapidKeysAsReloaded(vapid_key_data)

	registerSubscriptionOnServer(subscription, "new");
	// document.getElementById("confirm-modal").checked = true
      }).catch((error) => alert(error.message))
  }).catch((e) => {
    console.log("Could not load vapid public key: maybe user hasn't logged in yet", e)
  })
}

export function unsubscribe(registration) {
  return registration.pushManager.getSubscription().then((subscription) => {
    return subscription.unsubscribe().then(() => {
      return fetch("/api/v1/notification/unregister", {
	  method: "POST",
	  headers: {'Content-Type': 'application/json'},
	  body: JSON.stringify({subscription})
      })
    })
  })
}
